module.exports = __webpack_public_path__ + "img/CRM-No-Appointments.13bb5767.svg";